import React from "react";
import { connect } from "react-redux";
import { Detail, mapStateToProps } from "pages/Invoices/Detail";
import {
	fetchAvoir,
	updateAvoir,
	proceedAvoir,
	createAvoirRejection,
} from "redux/actions/Avoirs";
import {
	fetchDocumentInvoice,
	fetchRejectionMotifs,
	fetchPaymentTerms,
	fetchBillingLines,
	topayInvoice,
	createInvoiceApproval,
	fetchGlAccounts,
	fetchCostCenters,
	fetchPaymentMethods,
} from "redux/actions/invoices";
import { updateFormulaire } from "redux/formulaireReducer";

function AvoirDetail(props) {
	const match = {
		...props.match,
		params: { ...props.match.params, idInvoice: props.match.params.idAvoir },
	};
	return <Detail {...props} match={match} isAvoir />;
}

const mapAvoirStateToProps = (state, ownProps) => mapStateToProps(state, { ...ownProps, isAvoir: true });

export default connect(mapAvoirStateToProps, {
	fetchInvoice: fetchAvoir,
	updateInvoice: updateAvoir,
	proceedAvoir,
	// La boîte de dialogue de rejet partagée appelle `props.createInvoiceRejection` : la pointer sur
	// l'action des avoirs suffit à la réutiliser sans la dupliquer.
	createInvoiceRejection: createAvoirRejection,
	fetchDocumentInvoice,
	fetchRejectionMotifs,
	fetchPaymentTerms,
	fetchBillingLines,
	topayInvoice,
	createInvoiceApproval,
	fetchGlAccounts,
	fetchCostCenters,
	fetchPaymentMethods,
	updateFormulaire,
})(AvoirDetail);
